module.exports = __webpack_public_path__ + "static/glass_ball_w320-7a577d6a391299be50a68202bebd907c.png";